import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios/index';

class Actions extends React.Component {
  render() {
    return (
      <div>
        <a href='#' className="btn btn-text pull-right" onClick={this.handlerDelete}>
          DELETE
        </a>
        <a href='#' className="btn btn-text pull-right" onClick={this.handlerEdit}>
          EDIT
        </a>
      </div>
    );
  }

  handlerEdit = (e) => {
    e.preventDefault();
    this.props.onAction({ type: 'edit', payload: { id: this.props.id } });
  };

  handlerDelete = (e) => {
    e.preventDefault();
    if (!confirm('Are You sure?')) {
      return;
    }
    this.props.onAction({ type: 'deleted', payload: { id: this.props.id } });

    axios.delete(`/groups/${this.props.id}`);

    toastr.success('Group Deleted');
  };
}

Actions.propTypes = {
  id: PropTypes.number.isRequired,
  onAction: PropTypes.func
};

export default Actions;
